import React from 'react'
import { Link } from 'gatsby'
import Helmet from 'react-helmet'
import Waypoint from 'react-waypoint'

import Layout from '../components/layout'
import Nav from '../components/Nav'
import Scroll from '../components/Scroll'
import pic01 from '../assets/images/pic01.jpg'

import ReactModal from 'react-modal'
import logo from '../assets/images/logo1.svg';
import badge from '../assets/images/badge1.svg';

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
      stickyNav: false
    }
  }

  _handleWaypointEnter= () => {
    this.setState(() => ({ stickyNav: false }));
  }

  _handleWaypointLeave = () => {
    this.setState(() => ({ stickyNav: true }));
  }

  _handleModalOpen = event => {
    this.setState({ isModalOpen: true })
  }

  _handleModalClose = event => {
    this.setState({ isModalOpen: false })
  }

  render() {

    return (
      <Layout>
        <Helmet title="Badgista" />

        <header id="header" className="alt">
          <span className="logo"><img src={logo} alt="" /></span>
          <p>Engage users with game mechanics, like badges and level bars.<br/> Directly on your website. Almost no configuration required.</p>
          <ul className="actions">
            <li><Link to="#" className="button" onClick={this._handleModalOpen}>See What It Looks Like</Link></li>
            <li>
                <Scroll type="id" element="cta">
                  <Link to="#" className="button special">Get Early Access</Link>
                </Scroll>
            </li>
          </ul>
        </header>

        <Waypoint
          onEnter={this._handleWaypointEnter}
          onLeave={this._handleWaypointLeave}
        >
        </Waypoint>
        <Nav sticky={this.state.stickyNav} />

        <ReactModal
          isOpen={this.state.isModalOpen}
          onRequestClose={this._handleModalClose}
          contentLabel="Example Modal In Gatsby"
          overlayClassName="modal"
          className="modal-content"
        >
          <h2>Congratulations</h2>
          <h3>You've got a new badge!</h3>
          <span className="logo"><img src={badge} alt="" /></span>
          <p>Continue using the website to get more badges</p>
          <Link to="#" onClick={this._handleModalClose} className="button special">Nice!</Link>
        </ReactModal>

        <div id="main">

          <section id="why" className="main">
            <div className="spotlight">
              <div className="content">
                <header className="major">
                  <h2>Gamification</h2>
                </header>
                <p>Gamification can boost conversions up to <b>7x</b>, but small businesses have been shying away from it because of the emphasis on large, global enterprises deploying the technology. <br/>
      With <b>Badgista</b> even small businesses can easily implement game mechanics and reach their goals.</p>
              </div>
              <span className="icon image major style1 fa-gamepad"></span>
            </div>
          </section>

          <section id="how" className="main special">
            <header className="major">
              <h2>Installation</h2>
            </header>
            <ul className="features">
              <li>
                <span className="icon major style1 fa-code"></span>
                <h3>3 lines of code</h3>
                <p>You need to add only 3 lines of code to start working with Badgista. Easier than analytics.</p>
              </li>
              <li>
                <span className="icon major style3 fa-cog"></span>
                <h3>Simple configuration</h3>
                <p>Create new badges with just a few clicks. Set rules for when users should get them and reach higher levels.</p>
              </li>
              <li>
                <span className="icon major style5 fa-check"></span>
                <h3>Multiple displaying options</h3>
                <p>Expand users’ experiences by displaying what they have achieved, and what is yet to be achieved. Directly on your website.</p>
              </li>
            </ul>
          </section>


          <section id="cta" className="main special">
            <header className="major">
              <h2>Get Started</h2>
              <p>Join the early access now and get all benefits first</p>
            </header>
            <footer className="major">



      <div id="mc_embed_signup">
        <form action="https://gmail.us3.list-manage.com/subscribe/post?u=ecb96d18ffc8a03a0a7959b63&amp;id=b8a8e26a8e" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
          <div id="mc_embed_signup_scroll">
            <input type="email" name="EMAIL" class="email" placeholder="Email address" required/>
              <div aria-hidden="true" style={{display: 'none'}}>
              <input type="text" name="b_ecb96d18ffc8a03a0a7959b63_b8a8e26a8e" tabindex="-1" value=""/>
            </div>

            <ul className="actions">
              <li>
                <input type="submit" value="Get Early Access" name="subscribe" id="mc-embedded-subscribe" class="button special"/>
              </li>
            </ul>
          </div>
        </form>
      </div>





            </footer>
          </section>

        </div>

      </Layout>
    )
  }
}

export default Index
